






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class Recaptcha extends Vue {
	@Prop({required: true}) sitekey: string; // v3_site_key
	@Prop({required: false, default: 'recaptcha-default-script'}) scriptId: string;

	public scriptUrl: string = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit';

	public widgetId: number = -1;

	public async apiLoaded(): Promise<void> {
		const options = {
			size: 'invisible',
			sitekey: this.sitekey,
			'callback': this.emitVerify,
			'expired-callback': this.emitExpired,
			'error-callback': this.emitError
		};

		const container = this.$slots.default ? this.$el.children[0] : this.$el;
		this.widgetId = await window.grecaptcha.render(container, options);

		this.$emit('render', {
			widgetId: this.widgetId,
			widget: this
		});
	}

	public async execute(): Promise<string> {
		const token: string = await new Promise((resolve) => {
			grecaptcha.ready(async () => {
				resolve(await grecaptcha.execute(this.widgetId));
			});
		});

		this.$emit('execute', token);

		return token;
	}

	public emitVerify(response: any): void {
		this.$emit('verify', response);
	}

	public emitExpired(): void {
		this.$emit('expired');
	}

	public emitError(): void {
		this.$emit('error');
	}

	private beforeMount(): void {
		if (typeof window === 'undefined') {
			return;
		}

		if (!document.getElementById(this.scriptId)) {
			const script = document.createElement('script');
			script.id = this.scriptId;
			script.src = this.scriptUrl;
			script.async = true;
			script.defer = true;

			document.head.appendChild(script);
		}
	}

	private mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
		window.vueRecaptchaApiLoaded = this.apiLoaded.bind(this);
	}
}
